
import { LeadershipSection } from "@/components/board/LeadershipSection";
import { BoardGrid } from "@/components/board/BoardGrid";
import { BoardMemberProps } from "@/types/board";
import Navbar from "@/components/Navbar";
import Footer from "@/components/sections/Footer";
import { SEO } from "@/components/SEO";

const BoardMembers = () => {
  console.log("Rendering BoardMembers component");
  
  const boardMembers: BoardMemberProps[] = [
    {
      name: "Mike Wilson",
      role: "Chairman",
      description: "Mike Wilson runs the family farm alongside his wife Carol and parents growing 80 ha of high grade seed potatoes mostly for seed growers in Scotland. The main part of the business is fattening cattle with the majority of the 1500 acres of cereals grown on the farm fed to cattle that are bought in from local markets. Grass and OSR are also grown alongside potatoes providing ideal break crops on a mixed rotation enterprise.",
      imageUrl: "/lovable-uploads/2e82d3ff-99c5-4e60-a61c-889421849fc7.png"
    },
    {
      name: "Jim Cargill",
      role: "Vice Chair & Secretary",
      description: "A second generation farmer, Jim Cargill is a foundational director of SPO. Based at Coldstream Farm he produces seed potatoes for export, and the domestic market, cereals and daffodil bulbs. A past board member at Grampian Growers and longstanding director, AHDB council member on the seed potato board, board member at SAOS, and chairman at Angus cereals. \"I understood the issues with AHDB this is why we have created SPO, to represent seed potato growers, & address relevant issues to help the industry develop\"",
      imageUrl: "/lovable-uploads/4d4377ca-2737-49b4-959d-471c95635aa1.png"
    },
    {
      name: "Graham Twatt",
      role: "Director",
      description: "Alan Twatt (Potatoes) Ltd is a family run grower/merchant business that my father started 65 years ago. I have been part of it now, for over 35 years. All our potatoes are grown for seed with approx. 70% going abroad. I am very much involved in the day to day running of the business, with over 145Ha grown on our own farms. We are now growing mini tubers for multiplication for our growers and our own use."
    },
    {
      name: "Ian Toth",
      role: "Director",
      description: "Ian Toth currently works for the James Hutton Institute. He has an active research team whose focus is on the Epidemiology, aetiology and control of blackleg disease caused by Pectobacterium and Dickeya species. More recently, following a Scottish Government working group (which he led), he is part of a £2.3 million project on sustainable management of potato cyst nematodes (PCN). He has over 100 refereed papers and book chapters and an H-index (Google Scholar) of 50, and in 2021 co-edited the first book dedicated to the soft rot Pectobacteriaceae (SRP)."
    },
    {
      name: "Patrick Hughes",
      role: "Director",
      description: "Patrick Hughes currently leads on identifying, understanding and developing new opportunities for Scottish Agricultural Exports. Patrick works with the Scottish potato, cereal, fruit and vegetable sectors to both maintain the current market position while also exploring further opportunities overseas. \"I joined the SPO board to ensure the support offered by the Scottish Agri Export Hub and key stakeholders withing the seed potato supply chain are aligned to assist in the continued development of the seed potato sector.\""
    },
    {
      name: "Kerr Howatson",
      role: "Director",
      description: ""
    },
    {
      name: "Philip Gray",
      role: "Director",
      description: ""
    },
    {
      name: "Johnnie Martin",
      role: "Director",
      description: "Johnnie Martin is a PB grower and one of the partners in a fourth generation family business first established by his grandfather in 1947 on the Black Isle."
    },
    {
      name: "Collin Massie",
      role: "Director",
      description: "A PB Seed grower in Aberdeenshire"
    },
    {
      name: "Peter Shiells",
      role: "Director",
      description: "Is the Potato Manager at Mertoun Estate Farms in the Borders."
    }
  ];

  console.log("Board members data:", boardMembers);

  const [chairman, viceChair, ...otherMembers] = boardMembers;
  const leaders = [chairman, viceChair];

  console.log("Leaders:", leaders);
  console.log("Other members:", otherMembers);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Our Board Members" 
        description="Meet the dedicated professionals leading the Seed Potato Organisation towards a sustainable and innovative future."
        keywords={["seed potato board", "potato industry leadership", "Scottish seed potato", "agricultural leadership"]}
      />
      <Navbar />
      <div className="flex-grow bg-gradient-to-b from-muted to-white">
        <div className="container mx-auto px-4 pt-28 pb-16">
          <div className="text-center mb-16 animate-fade-up">
            <h1 className="text-4xl font-bold text-primary mb-4">Our Board Members</h1>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Meet the dedicated professionals leading the Seed Potato Organisation towards a sustainable and innovative future.
            </p>
          </div>

          <LeadershipSection leaders={leaders} />
          <BoardGrid members={otherMembers} startDelay={2} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BoardMembers;
